import { copySteps as clipboardCopy } from './clipboardService';
import { showSnackbar } from '../../features/snakbar/snackbarSlice';
import { TOASTS } from './copyPasteConstants';

/**
 * Orchestrate a Copy action from the UI.
 * - Returns silently when selection is empty (no toast).
 * - Refuses entirely if any selected step has customStep !== true.
 * - Writes to the system clipboard via clipboardService.
 * - Emits a snackbar toast for every terminal state.
 *
 * Signature: copyStepsAction({ getState, dispatch })
 *   getState(): returns { instructions, selectedStepIds, testCaseId }
 */
export async function copyStepsAction({ getState, dispatch }) {
  const { instructions, selectedStepIds, testCaseId } = getState();
  if (!selectedStepIds || selectedStepIds.length === 0) return;

  // Materialize the step objects for the selected ids (in source-step order).
  const idSet = new Set(selectedStepIds);
  const stepsInOrder = [];
  for (const inst of instructions ?? []) {
    for (const s of inst.aiSteps ?? []) {
      if (idSet.has(s.id)) stepsInOrder.push(s);
    }
  }

  // Gate: every selected step must have customStep === true.
  if (stepsInOrder.some(s => s.customStep !== true)) {
    dispatch(showSnackbar({ message: TOASTS.COPY_ONLY_CUSTOM, severity: 'info', duration: 4000 }));
    return;
  }

  try {
    await clipboardCopy(stepsInOrder, testCaseId);
    dispatch(showSnackbar({
      message: TOASTS.COPY_OK(stepsInOrder.length),
      severity: 'success',
      duration: 4000,
    }));
  } catch {
    dispatch(showSnackbar({
      message: TOASTS.COPY_ACCESS_BLOCKED,
      severity: 'error',
      duration: 4000,
    }));
  }
}
